// -----------------------------------------------------------------------------
//
// This file is the copyrighted property of Tableau Software and is protected
// by registered patents and other applicable U.S. and international laws and
// regulations.
//
// Unlicensed use of the contents of this file is prohibited. Please refer to
// the NOTICES.txt file for further details.
//
// -----------------------------------------------------------------------------
import { call, put } from 'redux-saga/effects';

import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { ResumeExtractTasksAction } from '../../extract/services/ResumeExtractTasksAction';
import { IExtractTaskInfo } from '../../ts/models/IExtractTaskInfo';
import { Set } from '../../ts/models/Set';
import { ResumeExtractRefreshAction } from '../actions/ResumeExtractRefreshAction';

export function* handleResumeExtractRefreshAction(action: ResumeExtractRefreshAction) {
  try {
    yield call(executeResumeExtractRefresh, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeResumeExtractRefresh(items: IExtractTaskInfo[]) {
  return ResumeExtractTasksAction.execute(Set.fromIdItemArray(items));
}
